import { createSlice } from "@reduxjs/toolkit";

interface extendModalData {
  extendModalType: "Session" | "Agenda" | "Event";
  endDate: string | null;
  openModal: boolean;
}
interface Ids {
  eventId: string | null;
  sessionId: string | null;
  agendaId: string | null;
}
interface AgendaModalData {
  modalOpen: boolean;
  cancelAgendaModal: boolean;
  agendaStartDate: string | null;
  agendaEndDate: string | null;
  agendaId: string | null;
}
interface ApiResponse {
  success: any;
  error: any;
}
interface EditAgendaModal {
  modalOpen: boolean;
  agendaData: any;
  isClone: boolean;
}
interface SessionModalData {
  modalOpen: boolean;
  cancelSessionModal: boolean;
  remarks: string;
  sessionId: string;
}

export interface EventExtensionSliceState {
  sessionListData: any;
  agendaList: any;
  agendaData: any;
  sessiondata: any;
  agendaModalData: AgendaModalData;
  extendModalData: extendModalData;
  extendedDate: string | null;
  ids: Ids;
  apiResponse: ApiResponse;
  editAgendaModal: EditAgendaModal;
  sessionModalData: SessionModalData;
}

const initialState: EventExtensionSliceState = {
  sessionListData: [],
  agendaList: {},
  extendModalData: {
    extendModalType: "Event",
    endDate: null,
    openModal: false
  },
  extendedDate: null,
  ids: {
    eventId: null,
    sessionId: "",
    agendaId: null
  },
  agendaData: {},
  sessiondata: {},
  sessionModalData: {
    modalOpen: false,
    cancelSessionModal: false,
    remarks: "",
    sessionId: ""
  },
  agendaModalData: {
    modalOpen: false,
    cancelAgendaModal: false,
    agendaId: null,
    agendaStartDate: null,
    agendaEndDate: null
  },
  apiResponse: {
    success: {},
    error: {}
  },
  editAgendaModal: {
    modalOpen: false,
    agendaData: {},
    isClone: false
  }
};

const EventExtensionSlice = createSlice({
  name: "eventExtensionSlice",
  initialState,
  reducers: {
    addSessionListData(state, action) {
      state.sessionListData = action.payload;
    },
    addAgendaList(state, action) {
      state.agendaList = action.payload;
    },
    setExtendModalData(state, action) {
      state.extendModalData = action.payload;
    },
    closeExtendTimelineModal(state) {
      state.extendModalData.openModal = false;
    },
    setExtendedDate(state, action) {
      state.extendedDate = action.payload;
    },
    resetExtendedDate(state) {
      state.extendedDate = null;
    },
    setAgendaData(state, action) {
      state.agendaData = action.payload;
    },
    setAgendaModalData(state, action) {
      state.agendaModalData = {
        ...state.agendaModalData,
        ...action.payload
      };
    },
    setIds(state, action) {
      state.ids = {
        ...state.ids,
        ...action.payload
      };
    },
    resetIds(state) {
      state.ids = initialState.ids;
    },
    setSuccessResponse(state, action) {
      state.apiResponse.success = action.payload;
    },
    setErrorResponse(state, action) {
      state.apiResponse.error = action.payload;
    },
    setEditAgendaModal(state, action) {
      state.editAgendaModal = {
        ...state.editAgendaModal,
        ...action.payload
      };
    },
    setSessionData(state, action) {
      state.sessiondata = action.payload;
    },
    setSessionModalData(state, action) {
      state.sessionModalData = {
        ...state.sessionModalData,
        ...action.payload
      };
    }
  }
});

export default EventExtensionSlice;

export const EventExtensionSliceActions = EventExtensionSlice.actions;
